/* ============================================================
   FERCCINI · Motor de animación
   Sin librerías externas. Solo transform y opacity (GPU).
   Un único IntersectionObserver para toda la página.
   Todo se apaga con prefers-reduced-motion.

   Regla de oro: lo que ya está en pantalla al cargar se muestra
   de inmediato, sin esperar al observador.

   Los reveals SE REPITEN: cada elemento vuelve a animarse cada vez
   que entra en el viewport (subiendo o bajando), no una sola vez.
   ============================================================ */
(function () {
  'use strict';

  if (window.__ferccini_anim) return;
  window.__ferccini_anim = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esTactil = window.matchMedia('(hover: none)').matches;
  if (!reduce) document.documentElement.classList.add('fc-anim');

  var observer = null;

  function mostrarTodo() {
    document.querySelectorAll('[data-fc-reveal]').forEach(function (el) { el.classList.add('fc-visible'); });
  }

  function initReveals() {
    if (reduce || !('IntersectionObserver' in window)) { mostrarTodo(); return; }
    if (!observer) {
      observer = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          // Se repite siempre: aparece al entrar, se reinicia al salir.
          e.target.classList.toggle('fc-visible', e.isIntersecting);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    }
    registrar();
    // Seguro: si algo impidiera que el observador dispare, a los 2,5 s
    // se muestra lo que esté en pantalla.
    setTimeout(function () {
      document.querySelectorAll('[data-fc-reveal]:not(.fc-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('fc-visible');
      });
    }, 2500);
  }

  function registrar() {
    document.querySelectorAll('[data-fc-reveal]').forEach(function (el) {
      if (el.dataset.fcRegistrado) return;
      el.dataset.fcRegistrado = '1';
      var grupo = el.closest('[data-fc-grupo]');
      if (grupo) {
        var hermanos = Array.prototype.slice.call(grupo.querySelectorAll('[data-fc-reveal]'));
        var i = hermanos.indexOf(el);
        var paso = parseFloat(grupo.dataset.fcGrupo) || 0.08;
        if (i > 0) el.style.setProperty('--fc-delay', (i * paso).toFixed(2) + 's');
      }
      if (!observer) { el.classList.add('fc-visible'); return; }
      // Ya visible al cargar: se muestra sin esperar (evita el parpadeo inicial).
      if (el.getBoundingClientRect().top < window.innerHeight * 0.95) {
        requestAnimationFrame(function () { el.classList.add('fc-visible'); });
      }
      // Siempre observado: el reveal se repite cada vez que entra en pantalla.
      observer.observe(el);
    });
  }

  function initLineas() {
    document.querySelectorAll('[data-fc-lineas]').forEach(function (el) {
      if (el.dataset.fcListo) return;
      el.dataset.fcListo = '1';
      var texto = (el.textContent || '').trim();
      var lineas = texto.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
      if (!lineas.length) return;
      el.textContent = '';
      el.classList.add('fc-lineas');
      lineas.forEach(function (linea, i) {
        var wrap = document.createElement('span');
        wrap.className = 'fc-linea-wrap';
        var span = document.createElement('span');
        span.className = 'fc-linea';
        span.style.setProperty('--fc-delay', (i * 0.12).toFixed(2) + 's');
        span.textContent = linea;
        wrap.appendChild(span);
        el.appendChild(wrap);
      });
      el.setAttribute('data-fc-reveal', '');
      el.style.setProperty('--fc-reveal-y', '0px');
    });
  }

  var capas = [], tickeando = false;
  function initParallax() {
    if (reduce) return;
    capas = Array.prototype.slice.call(document.querySelectorAll('[data-fc-parallax]'));
    if (!capas.length) return;
    capas.forEach(function (c) { c.classList.add('fc-parallax'); });
    pintarParallax();
    window.addEventListener('scroll', pedirPintado, { passive: true });
    window.addEventListener('resize', pedirPintado, { passive: true });
  }
  function pedirPintado() {
    if (tickeando) return;
    tickeando = true;
    requestAnimationFrame(function () { pintarParallax(); tickeando = false; });
  }
  function pintarParallax() {
    var vh = window.innerHeight;
    capas.forEach(function (capa) {
      var caja = capa.getBoundingClientRect();
      if (caja.bottom < -200 || caja.top > vh + 200) return;
      var fuerza = parseFloat(capa.dataset.fcParallax) || 12;
      var centro = caja.top + caja.height / 2;
      var avance = (centro - vh / 2) / vh;
      capa.style.setProperty('--fc-par', (avance * fuerza * -1).toFixed(2) + 'vh');
    });
  }

  function initCursor() {
    if (reduce || esTactil) return;
    var zonas = document.querySelectorAll('[data-fc-cursor]');
    if (!zonas.length || document.querySelector('.fc-cursor')) return;
    var cursor = document.createElement('div');
    cursor.className = 'fc-cursor';
    document.body.appendChild(cursor);
    var x = 0, y = 0, cx = 0, cy = 0, activo = false, animando = false;
    function bucle() {
      cx += (x - cx) * 0.18; cy += (y - cy) * 0.18;
      cursor.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      if (activo && (Math.abs(x - cx) > 0.4 || Math.abs(y - cy) > 0.4)) requestAnimationFrame(bucle);
      else animando = false;
    }
    document.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      if (activo && !animando) { animando = true; requestAnimationFrame(bucle); }
    }, { passive: true });
    zonas.forEach(function (zona) {
      zona.addEventListener('mouseenter', function () {
        cursor.textContent = zona.dataset.fcCursor || 'Ver';
        cursor.classList.add('is-activo');
        activo = true;
        if (!animando) { animando = true; requestAnimationFrame(bucle); }
      });
      zona.addEventListener('mouseleave', function () { cursor.classList.remove('is-activo'); activo = false; });
    });
  }

  function initCarruseles() {
    document.querySelectorAll('[data-fc-carrusel]').forEach(function (pista) {
      if (pista.dataset.fcListo) return;
      pista.dataset.fcListo = '1';
      var abajo = false, xInicio = 0, scrollInicio = 0, movido = false;
      pista.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        abajo = true; movido = false;
        xInicio = e.clientX; scrollInicio = pista.scrollLeft;
      });
      pista.addEventListener('pointermove', function (e) {
        if (!abajo) return;
        var d = e.clientX - xInicio;
        // Solo se considera arrastre (y se captura el puntero) tras un
        // movimiento real; así un clic limpio deja navegar al enlace.
        if (Math.abs(d) > 5 && !movido) {
          movido = true;
          pista.classList.add('is-arrastrando');
          try { pista.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (movido) { pista.scrollLeft = scrollInicio - d; e.preventDefault(); }
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        pista.addEventListener(ev, function () { abajo = false; pista.classList.remove('is-arrastrando'); });
      });
      pista.addEventListener('click', function (e) { if (movido) { e.preventDefault(); e.stopPropagation(); } }, true);
      var barra = pista.parentElement.querySelector('[data-fc-barra] span');
      if (barra) {
        var pintar = function () {
          var max = pista.scrollWidth - pista.clientWidth;
          var visible = Math.min(pista.clientWidth / pista.scrollWidth, 1);
          var avance = max > 0 ? pista.scrollLeft / max : 0;
          barra.style.width = (visible * 100).toFixed(1) + '%';
          barra.style.transform = 'translateX(' + (avance * (100 / visible - 100)).toFixed(1) + '%)';
        };
        pista.addEventListener('scroll', function () { requestAnimationFrame(pintar); }, { passive: true });
        window.addEventListener('resize', pintar);
        pintar();
      }
    });
  }

  function initCifras() {
    var cifras = document.querySelectorAll('[data-fc-cifra]');
    if (!cifras.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      cifras.forEach(function (el) { el.textContent = el.dataset.fcCifra; });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        contar(e.target);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    cifras.forEach(function (el) {
      if (el.dataset.fcListo) return;
      el.dataset.fcListo = '1';
      if (el.getBoundingClientRect().top < window.innerHeight) { contar(el); return; }
      el.textContent = '0';
      obs.observe(el);
    });
  }
  function contar(el) {
    var destino = parseInt(el.dataset.fcCifra, 10) || 0;
    var dur = 1500, t0 = null;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(destino * eased).toString();
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function initTrazos() {
    document.querySelectorAll('[data-fc-trazo] path, [data-fc-trazo] circle, [data-fc-trazo] rect, [data-fc-trazo] line').forEach(function (forma) {
      var len = 0;
      try { len = forma.getTotalLength ? forma.getTotalLength() : 0; } catch (err) { len = 0; }
      if (!len) len = 220;
      forma.style.setProperty('--fc-len', Math.ceil(len + 2));
    });
  }

  function initGaleria() {
    var galeria = document.querySelector('[data-fc-galeria]');
    if (!galeria) return;
    var principal = galeria.querySelector('[data-fc-principal]');
    galeria.querySelectorAll('[data-fc-mini]').forEach(function (mini) {
      if (mini.dataset.fcListo) return;
      mini.dataset.fcListo = '1';
      mini.addEventListener('click', function () {
        if (!principal) return;
        principal.src = mini.dataset.fcMini;
        galeria.querySelectorAll('[data-fc-mini]').forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  }

  function arrancar() {
    initLineas();
    initTrazos();
    initReveals();
    initParallax();
    initCursor();
    initCarruseles();
    initCifras();
    initGaleria();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  window.addEventListener('load', function () { registrar(); initCifras(); });
  document.addEventListener('shopify:section:load', arrancar);
})();
